import type { MetaLang } from '../hooks/useCurrentLang';
import { ARDSHINBANK_HOME_URL } from '../constants/links';

/** Bank website locale query values (`am` in this app is `hy` on ardshinbank.am). */
const BANK_SITE_LANG: Record<MetaLang, 'hy' | 'ru' | 'en'> = {
    am: 'hy',
    ru: 'ru',
    en: 'en',
};

export function getArdshinbankHomeUrl(lang: MetaLang): string {
    const url = new URL(ARDSHINBANK_HOME_URL);
    url.searchParams.set('lang', BANK_SITE_LANG[lang]);
    return url.toString();
}
